import _defineProperty from "/home/runner/work/pc123-gatsby/pc123-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from "react";
import { ACTION_NEXT, ACTION_PREV, ACTION_SWIPE, CLASS_FLEX_CENTER, cleanup, clsx, cssClass, cssVar, getSlide, useAnimation, useEventCallback, useEvents, useLightboxState, useRTL } from "../../core/index.js";
import { cssPrefix, cssThumbnailPrefix } from "./utils.js";
import { Thumbnail } from "./Thumbnail.js";
import { defaultThumbnailsProps } from "./Thumbnails.js";

function isHorizontal(position) {
  return ["top", "bottom"].includes(position);
}

function boxSize(thumbnails, dimension, includeGap) {
  return dimension + 2 * (thumbnails.border + thumbnails.padding) + (includeGap ? thumbnails.gap : 0);
}

export function ThumbnailsTrack(_ref) {
  var container = _ref.container,
      slides = _ref.slides,
      carousel = _ref.carousel,
      render = _ref.render,
      thumbnails = _ref.thumbnails,
      thumbnailRect = _ref.thumbnailRect,
      styles = _ref.styles;
  var track = React.useRef(null);
  var _useLightboxState$sta = useLightboxState().state,
      globalIndex = _useLightboxState$sta.globalIndex,
      animation = _useLightboxState$sta.animation;

  var _useEvents = useEvents(),
      publish = _useEvents.publish,
      subscribe = _useEvents.subscribe;

  var isRTL = useRTL();
  var index = globalIndex;
  var animationDuration = (animation === null || animation === void 0 ? void 0 : animation.duration) || 0;
  var offset = animationDuration > 0 && (animation === null || animation === void 0 ? void 0 : animation.increment) || 0;
  var animate = useAnimation(track, function (snapshot) {
    return {
      keyframes: isHorizontal(thumbnails.position) ? [{
        transform: "translateX(".concat((isRTL ? -1 : 1) * boxSize(thumbnails, thumbnails.width, true) * offset + snapshot, "px)")
      }, {
        transform: "translateX(0)"
      }] : [{
        transform: "translateY(".concat(boxSize(thumbnails, thumbnails.height, true) * offset + snapshot, "px)")
      }, {
        transform: "translateY(0)"
      }],
      duration: animationDuration,
      easing: animation === null || animation === void 0 ? void 0 : animation.easing
    };
  });
  var handleControllerSwipe = useEventCallback(function () {
    var animationOffset;

    if (container.current && track.current) {
      var containerRect = container.current.getBoundingClientRect();
      var trackRect = track.current.getBoundingClientRect();
      animationOffset = isHorizontal(thumbnails.position) ? trackRect.left - containerRect.left - (containerRect.width - trackRect.width) / 2 : trackRect.top - containerRect.top - (containerRect.height - trackRect.height) / 2;
    } else {
      animationOffset = 0;
    }

    animate(animationOffset);
  });
  React.useEffect(function () {
    return cleanup(subscribe(ACTION_SWIPE, handleControllerSwipe));
  }, [subscribe, handleControllerSwipe]);
  var finite = carousel.finite;
  var preload = Math.max(Math.min(carousel.preload, slides.length - 1), 0);
  var items = [];

  if (slides.length > 0) {
    if (offset < 0) {
      for (var i = index - preload + offset; i < index - preload; i += 1) {
        items.push({
          slide: null,
          index: i,
          placeholder: true
        });
      }
    }

    for (var _i = index - preload - (offset > 0 ? offset : 0); _i < index; _i += 1) {
      if (!(finite && _i < 0)) {
        items.push({
          slide: getSlide(slides, _i),
          index: _i
        });
      } else {
        items.push({
          slide: null,
          index: _i,
          placeholder: true
        });
      }
    }

    items.push({
      slide: getSlide(slides, index),
      index: index
    });

    for (var _i2 = index + 1; _i2 <= index + preload - (offset < 0 ? offset : 0); _i2 += 1) {
      if (!finite || _i2 <= slides.length - 1) {
        items.push({
          slide: getSlide(slides, _i2),
          index: _i2
        });
      } else {
        items.push({
          slide: null,
          index: _i2,
          placeholder: true
        });
      }
    }

    if (offset > 0) {
      for (var _i3 = index + preload + 1; _i3 <= index + preload + offset; _i3 += 1) {
        items.push({
          slide: null,
          index: _i3,
          placeholder: true
        });
      }
    }
  }

  var handleClick = function handleClick(slideIndex) {
    return function () {
      if (slideIndex > index) {
        publish(ACTION_NEXT, {
          count: slideIndex - index
        });
      } else if (slideIndex < index) {
        publish(ACTION_PREV, {
          count: index - slideIndex
        });
      }
    };
  };

  var width = thumbnails.width,
      height = thumbnails.height,
      border = thumbnails.border,
      borderRadius = thumbnails.borderRadius,
      padding = thumbnails.padding,
      gap = thumbnails.gap,
      imageFit = thumbnails.imageFit,
      vignette = thumbnails.vignette;
  return React.createElement("div", {
    className: clsx(cssClass(cssPrefix("container")), cssClass(CLASS_FLEX_CENTER)),
    style: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, width !== defaultThumbnailsProps.width ? _defineProperty({}, cssVar(cssThumbnailPrefix("width")), "".concat(boxSize(thumbnails, width), "px")) : null), height !== defaultThumbnailsProps.height ? _defineProperty({}, cssVar(cssThumbnailPrefix("height")), "".concat(boxSize(thumbnails, height), "px")) : null), border !== defaultThumbnailsProps.border ? _defineProperty({}, cssVar(cssThumbnailPrefix("border")), "".concat(border, "px")) : null), borderRadius !== defaultThumbnailsProps.borderRadius ? _defineProperty({}, cssVar(cssThumbnailPrefix("border_radius")), "".concat(borderRadius, "px")) : null), padding !== defaultThumbnailsProps.padding ? _defineProperty({}, cssVar(cssThumbnailPrefix("padding")), "".concat(padding, "px")) : null), gap !== defaultThumbnailsProps.gap ? _defineProperty({}, cssVar(cssThumbnailPrefix("gap")), "".concat(gap, "px")) : null), styles.thumbnailsContainer)
  }, React.createElement("nav", {
    ref: track,
    style: styles.thumbnailsTrack,
    className: clsx(cssClass(cssPrefix("track")), cssClass(CLASS_FLEX_CENTER))
  }, items.map(function (_ref8) {
    var slide = _ref8.slide,
        slideIndex = _ref8.index,
        placeholder = _ref8.placeholder;
    var fadeAnimationDuration = animationDuration / Math.abs(offset || 1);
    var fadeIn = offset > 0 && slideIndex > index + preload - offset && slideIndex <= index + preload || offset < 0 && slideIndex < index - preload - offset && slideIndex >= index - preload ? {
      duration: fadeAnimationDuration,
      delay: ((offset > 0 ? slideIndex - (index + preload - offset) : index - preload - offset - slideIndex) - 1) * fadeAnimationDuration
    } : undefined;
    var fadeOut = offset > 0 && slideIndex < index - preload || offset < 0 && slideIndex > index + preload ? {
      duration: fadeAnimationDuration,
      delay: (offset > 0 ? offset - (index - preload - slideIndex) : -offset - (slideIndex - (index + preload))) * fadeAnimationDuration
    } : undefined;
    return React.createElement(Thumbnail, {
      key: slideIndex,
      rect: thumbnailRect,
      slide: slide,
      imageFit: imageFit,
      render: render,
      active: slideIndex === index,
      fadeIn: fadeIn,
      fadeOut: fadeOut,
      placeholder: Boolean(placeholder),
      onClick: handleClick(slideIndex),
      style: styles.thumbnail
    });
  })), vignette && React.createElement("div", {
    className: cssClass(cssPrefix("vignette"))
  }));
}